import { axiosClient } from "@/shared/api/axios-client";
import type { SolicitudDetalle } from "@/lib/types";
import type { ProveedoresPorRfc } from "@/features/proveedor/types";

/**
 * Endpoints del paso "Proveedor" · agrupación por RFC + asignación
 * individual. El subtipo CFDI único usa la misma agrupación (devuelve
 * un solo grupo).
 */
export const proveedorApi = {
  consultarAgrupados: (solicitudId: string) =>
    axiosClient
      .get<ProveedoresPorRfc[]>(
        `/api/solicitudes/${solicitudId}/proveedores-agrupados`
      )
      .then((r) => r.data),

  seleccionarPorRfc: (
    solicitudId: string,
    rfcEmisor: string,
    numeroProveedor: number
  ) =>
    axiosClient
      .patch<SolicitudDetalle>(
        `/api/solicitudes/${solicitudId}/proveedor-por-rfc`,
        { rfcEmisor, numeroProveedor }
      )
      .then((r) => r.data),
};
